import { EventCodes } from '../../../../App/model/event-codes';

angular.module('mx.shell').component('mxShellToolbar', {
	controller: MxShellToolbarCtrl,
	controllerAs: 'vm',
	templateUrl: 'components/mx-shell-toolbar/mx-shell-toolbar.html',
});

MxShellToolbarCtrl.$inject = [
	'mx.shell.RoutingService',
	'mx.shell.AuthService',
	'mx.shell.ToolbarManager',
	'mx.shell.FeedbackProviderService',
	'mx.shell.UserProfileService',
	'mx.shell.InternationalizationService',
	'mx.shell.ActionManagerService',
	'mx.shell.SideLayout',
	'mx.shell.SidePanelService',
	'mx.shell.DataStorage',
	'mx.app.DeviceService',
	'mx.shell.NavigationManager',
	'mx.shell.AppsService',
	'mx.shell.Http',
	'$scope',
	'$timeout',
	'$q',
	'$element',
	'$mdSidenav',
	'mx.internationalization',
	'mx.shell.KeyboardNavigationService',
	'mx.shell.Config',
	'mx.shell.EventService',
	'mx.shell.LeftSidebarService',
	'mx.shell.AriaService',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.shell.ActionExecutorService',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.app.ThemeService',
];

/**
 * @ngdoc component
 * @name mx.shell:mxShellToolbar
 * @module mx.shell
 * @requires $mdSidenav
 * @requires {@ref mx.internationalization mx.internationalization}
 * @requires {@ref mx.shell.RoutingService mx.shell.RoutingService}
 * @requires {@ref mx.shell.AuthService mx.shell.AuthService}
 * @requires {@ref mx.shell.Config mx.shell.Config}
 * @requires {@ref mx.shell.EventService mx.shell.EventService}
 * @requires {@ref mx.shell.ToolbarManager mx.shell.ToolbarManager}
 * @requires {@ref mx.shell.FeedbackProviderService mx.shell.FeedbackProviderService}
 * @requires {@ref mx.shell.UserProfileService mx.shell.UserProfileService}
 * @requires {@ref mx.shell.InternationalizationService mx.shell.InternationalizationService}
 * @requires {@ref mx.shell.ActionManagerService mx.shell.ActionManagerService}
 * @requires {@ref mx.app.DeviceService mx.mx.components.DeviceService}
 * @requires {@ref mx.shell.NavigationManager mx.shell.NavigationManager}
 * @requires {@ref mx.shell.AppsService mx.shell.AppsService}
 * @requires {@ref mx.shell.Http mx.shell.Http}
 * @description
 * Main application toolbar
 * Contains {@ref mx.shell:mxSearch search control}, feedback button and {@ref mx.shell:mxShellAvatarSide user info section}
 * @usage <mx-shell-toolbar></mx-shell-toolbar>
 */
function MxShellToolbarCtrl(
	routingService,
	mxAuthService,
	toolbarManager,
	feedbackProviderService,
	userProfileService,
	i18nService,
	actionManagerService,
	sideLayout,
	sidePanelService,
	dataStorage,
	deviceService,
	navigationManager,
	appsService,
	mxHttp,
	$scope,
	$timeout,
	$q,
	$element,
	$mdSidenav,
	i18n,
	keyboardNavigationService,
	config,
	eventService,
	leftSidebarService,
	ariaService,
	dialogOpener,
	actionExecutorService,
	personalizationService,
	themeService
) {
	const vm = this;
	vm.leftSidebarService = leftSidebarService;

	const registerHotkeys = function () {
		keyboardNavigationService.registerKey({
			callback: function () {
				if ($('.mx-application-selection md-backdrop').length) {
					$('html').click();
					return;
				}

				$timeout(function () {
					$('.mx-application-selection:visible [ng-click]').click();

					$timeout(function () {
						$('mx-shell-toolbar md-bottom-sheet button:not(.md-autofocus)').eq(0).focus();
					});
				});
			},
			description: i18n.get('shell.mx-shell-toolbar.selectApplication'),
			key: 'alt+a',
			nameInTemplate: 'hintKey',
			scope: $scope,
		});
	};

	vm.ToolbarManager = toolbarManager;

	async function addAvatarMenuItems() {
		const [profile, languages] = await Promise.all([userProfileService.get(), i18nService.getLanguages()]);

		if (profile.profileDialogId) {
			toolbarManager.addAvatarDropdownItem({
				htmlClass: 'mx-toolbar-open-profile-page',
				icon: 'account_box',
				id: 'mx-shell-open-profile',
				label: i18n.get('shell.mx-shell-toolbar.profileLabel'),
				onItemClick: function () {
					const context = {
						_id: profile.objectId,
						_type: 'SPSUserType',
						_displayName: profile.accountName,
						_name: profile.accountName,
					};

					dialogOpener.openEditDialog(context, true, undefined, sidePanelService.currentView, {
						widgetId: profile.profileDialogId,
					});
				},
				position: 1,
			});
		}

		toolbarManager.addAvatarDropdownItem({
			htmlClass: 'mx-toolbar-sign-out',
			icon: 'close',
			id: 'mx-shell-sign-out',
			label: i18n.get('shell.mx-shell-toolbar.signOutLabel'),
			onItemClick: function () {
				eventService.dispatchEvent(EventCodes.TrackTelemetry, {
					eventName: 'User Signed Out',
				});
				mxAuthService.logout();
			},
			position: 900000000,
		});

		const currentApp = appsService.getCurrentApplication();
		currentApp.then(function (app) {
			const helpUri = app.helpValue || (config && config.settings && config.settings.helpUri);
			if (helpUri) {
				toolbarManager.addAvatarDropdownItem({
					htmlClass: 'mx-toolbar-help-center',
					icon: 'help',
					id: 'mx-shell-help-center',
					label: i18n.get('shell.mx-shell-toolbar.helpCenter'),
					onItemClick: function () {
						eventService.dispatchEvent(EventCodes.TrackTelemetry, {
							eventName: 'Help link opened',
						});
						window.open(helpUri, 'target=_blank');
					},
					position: 898000000,
				});
			}
		});

		toolbarManager.addAvatarDropdownItem({
			htmlClass: 'mx-toolbar-color-contrast',
			icon: mx.isEnhancedColorContrastMode ? 'check' : 'invert_colors',
			id: 'mx-toolbar-color-contrast',
			label: i18n.get('shell.mx-shell-toolbar.enhanceColorContrast') || 'Contrast',
			onItemClick: async () => {
				await themeService.toggleContrastMode();
				eventService.dispatchEvent(EventCodes.TrackTelemetry, {
					eventName: `Enhanced Color Contrasts ${mx.isEnhancedColorContrastMode ? 'activated' : 'deactivated'}`,
				});
				toolbarManager.avatarDropdownItems.find((item) => item.id === 'mx-toolbar-color-contrast').icon = mx.isEnhancedColorContrastMode ? 'check' : 'invert_colors';
			},
			position: 897000000,
		});

		if (Array.isArray(languages) && languages.length) {
			const children = languages
				.sort((lang1, lang2) => (lang1.title > lang2.title ? 1 : -1))
				.map((lang) => ({
					htmlClass: profile.languageId === lang.id ? 'mx-toolbar-current-language' : 'mx-toolbar-not-current-language',
					id: 'mx-shell-change-language-' + lang.code,
					languageId: lang.id,
					isDefaultUiLanguage: lang.isDefaultUiLanguage,
					iconStyle: _getLangIconStyle(lang),
					label: lang.title,
					onItemClick: async function () {
						eventService.dispatchEvent(EventCodes.TrackTelemetry, {
							eventName: 'UI Language changed',
							sender: lang.id,
							senderTitle: lang.code,
						});
						await userProfileService.changeLanguage(lang.id);
						window.forceReload();
					},
				}));

			toolbarManager.addAvatarDropdownItem({
				htmlClass: 'mx-toolbar-change-language',
				iconStyle: _getLangIconStyle(i18nService.currentLanguage),
				id: 'mx-shell-change-language',
				label: i18nService.currentLanguage.title,
				children: children,
				position: 200,
			});
		}

		let avatarMenuActions = await actionManagerService.getActions(new mx.shell.ActionsContext([], [], mx.shell.ActionUiZone.AvatarMenu));
		avatarMenuActions = await actionManagerService.filterActions(avatarMenuActions);

		avatarMenuActions.forEach((action) => {
			if (action.enabled) {
				toolbarManager.addAvatarDropdownItem({
					htmlClass: action.htmlClass || `mx-action--${action.name}`,
					icon: action.icon,
					id: `mx-action--${action.id}`,
					label: action.title,
					onItemClick: function () {
						actionExecutorService.execute(action).catch(mx.logCatch);
					},
					position: (parseInt(action.position) || 0) + 1000 /* All Avatar Menu Actions should be placed under `Languages` */,
				});
			}
		});
	}

	function _getLangIconStyle(lang) {
		let flagsHost = config.settings.imgHosts || {};
		flagsHost = flagsHost.flags || flagsHost.default || '';
		return {
			'background-image': lang.flagUrl ? 'url("' + flagsHost + lang.flagUrl + '")' : 'none',
			'background-size': '100%',
		};
	}

	vm.$onInit = function () {
		vm.searchContext = 'shell';
		vm.isVisible = true;
		vm.appsService = appsService;

		vm.FeedbackProviderService = feedbackProviderService;
		vm.NavigationManager = navigationManager;
		vm.deviceService = deviceService;
		vm.sideLayout = sideLayout;

		$q.all([userProfileService.get(), appsService.getCurrentApplication()]).then(function (params) {
			const profile = params[0];
			const currentApp = params[1];
			const settings = {
				applicationName: currentApp.name,
				productID: config.get('productId'),
				user: profile.accountName + ' [' + profile.email + ']',
				lang: i18nService.currentLanguage.twoLetterCode,
			};

			ariaService.handleAppSwitchingMessage(currentApp);
			ariaService.setAppInitialFocus();

			vm.showFeedback = function () {
				$.ajax({
					url: 'https://nps.azureedge.net/client/integration.js',
					dataType: 'script',
					success: function () {
						window.matrix42.nps.showModal(settings);
					},
					cache: true,
				});
			};
		});

		addAvatarMenuItems();

		eventService.subscribeTo(
			mx.shell.EventCodes.DisplayModeChanged,
			function (event, newMode) {
				const newModeIsNormal = newMode === mx.shell.DisplayMode.Normal;
				const toolbar = $('mx-shell-toolbar')[0];
				const propertyValue = newModeIsNormal ? '' : '0';

				vm.isVisible = newModeIsNormal;

				if (toolbar) {
					toolbar.style.minHeight = propertyValue;
					toolbar.style.height = propertyValue;
				}
			},
			$scope
		);
	};

	vm.$postLink = function () {
		registerHotkeys($scope, i18n, $timeout, keyboardNavigationService);
	};

	vm.goToDefaultRoot = function () {
		routingService.goToDefault();
	};

	vm.handleBurgerBtn = function () {
		if (deviceService.screenMobile()) {
			vm.toggleNav();
		} else {
			navigationManager.collapsedMode = !navigationManager.collapsedMode;
			if (localStorage) {
				localStorage.setItem('mxShellNavCollapsedMode', navigationManager.collapsedMode.toString().toLowerCase());
			}
		}
		eventService.dispatchEvent(EventCodes.TrackTelemetry, {
			eventName: navigationManager.collapsedMode ? 'Navigation collapsed' : 'Navigation expanded',
		});
	};

	MxShellToolbarCtrl.prototype.toggleNav = function () {
		$mdSidenav('mx-shell-left-sidebar').toggle();
		eventService.dispatchEvent(mx.shell.EventCodes.NavToggled);
	};
}
